module.exports = __webpack_public_path__ + "img/Mark.f3d4d233.jpg";